/**
 * @file システムエラーメッセージ表示。バリデーションエラーやAPI通信エラー時に赤文字でメッセージを表示。
 */
type Props = {
  message: string;
};

const SystemErrorMessage = ({ message }: Props) => {
  return <p className='note'>{message}</p>;
};

export default SystemErrorMessage;
